module.exports = __webpack_public_path__ + "static/media/bi_cash-stack.e4681794.svg";